import con from '../../../../connection';
import { ApiPostCompanyOrganizationsMergerResponse } from './api-post-organizations-merger-response';

const path = '/merger'

export const merger = (url: string) => () => ({
  post: (param: { to_organization_code: string }) =>
    con.post<ApiPostCompanyOrganizationsMergerResponse>(url + path, param),
})